import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchMapGlobalDashboard({ cSuitDateFilter, userEmail }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'kpi/GetCsuitGlobaldashboard?cSuitDateFilter=' + cSuitDateFilter + '&userEmail=' + userEmail,
    });
    const departmentsData = data;

    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setMapGlobalDashboard({ mapGlobalDashboard: departmentsData }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

function* fetchSiteKpiDashboard({ selectedSite, cSuitDateFilter, userEmail, pageNo }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `kpi/GetSiteKpisdashboard?siteName=${selectedSite}&cSuitDateFilter=${cSuitDateFilter}&userEmail=${userEmail}&pageNo=${pageNo}`,
    });
    const result = data ? data.toJS() : null;

    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setSiteKpiDashboard({ siteKpiDetailDashboard: result }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

function* fetchGlobalKpiDashboard({ cSuitDateFilter, userEmail, pageNo }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route:
        `kpi/GetCsuitGlobalKpisDashboardResult?cSuitDateFilter=${cSuitDateFilter}&userEmail=` +
        userEmail +
        `&pageNo=${pageNo}`,
    });
    const result = data ? data.toJS() : null;

    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setGlobalKpiDashboard({ globalKpiDashboard: result }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

function* fetchKpiDetailDashboard({ cSuitDateFilter, userEmail, selectedKpi, pageNo }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `kpi/GetKpisDetaildashboard?kpiId=${selectedKpi}&cSuitDateFilter=${cSuitDateFilter}&sortOrder="sortOrder"&userEmail=${userEmail}&pageNo=${pageNo}`,
    });
    const result = data ? data.toJS() : null;

    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setKpiDetailDashboard({ kpiDetailDashboard: result }));
  } catch (err) {
    console.warn(err);
  }
}

function* fetchSitePerformanceDetail({ cSuitDateFilter, selectedKpi, selectedSite }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `kpi/GetSiteKpiDetailDashboard?kpiId=${selectedKpi}&cSuitDateFilter=${cSuitDateFilter}&sortOrder="sortOrder"&siteName=${selectedSite}`,
    });
    const result = data ? data.toJS() : null;

    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setSitePerformanceDetail({ sitePerformanceDetail: result }));
  } catch (err) {
    console.warn(err);
  }
}
function* fetchKpiInformation({ selectedKpi, userEmail }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `kpi/GetKpiDetail?kpiId=${selectedKpi}&userEmail=${userEmail}`,
    });
    const result = data ? data.toJS() : null;

    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setSelectedKpiDetail({ selectedKpiDetail: result }));
  } catch (err) {
    console.warn(err);
  }
}
function* addUserKpi({ kpi, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    yield call(api.post, {
      route: `kpi/AddUserKpi`,
      data: kpi,
    });

    if (callback) callback();
    notification('success', CONSTANT_VARIABLES.C_SUITE_KPI_CREATED, '');
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchAllKpiByUser({ userEmail: kpi.userEmail }));
    yield put(Actions.fetchUserKpiList({ userEmail: kpi.userEmail }));
  } catch (err) {
    console.warn(err);
  }
}
function* fetchKpiList() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `kpi/GetAllKpi`,
    });
    const result = data ? data.toJS() : [];

    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setKpiList({ kpiList: result }));
  } catch (err) {
    console.warn(err);
  }
}
function* fetchAllKpiByUser({ userEmail }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `kpi/GetAllKpiByUser?userEmail=${userEmail}`,
    });
    const result = data ? data.toJS() : [];
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setAllKpiByUser({ allKpiByUser: result }));
  } catch (err) {
    console.warn(err);
  }
}
function* fetchUserKpiList({ userEmail }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `kpi/GetUserKpi?userEmail=${userEmail}`,
    });
    const result = data ? data.toJS() : [];
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setUserKpiList({ userKpiList: result }));
  } catch (err) {
    console.warn(err);
  }
}
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function* updateUserKpiSorting({ userEmail, userKpiList }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.put, {
      route: `kpi/UpdateUserKpiSorting/${userEmail}`,
      data: userKpiList,
    });
    const result = data ? data.toJS() : [];
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setUserKpiList({ userKpiList: result }));
  } catch (err) {
    console.warn(err);
  }
}
function* deleteUserKpi({ userEmail, selectedKpi }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    yield call(api.delete, {
      route: `kpi/DeleteUserKpi/${selectedKpi.kpiId}/${userEmail}`,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchUserKpiList({ userEmail }));
  } catch (err) {
    console.warn(err);
  }
}
function* updateUserKpi({ userEmail, selectedKpi }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    yield call(api.put, {
      route: `kpi/UpdateUserKpi/${userEmail}`,
      data: selectedKpi,
    });

    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchUserKpiList({ userEmail }));
  } catch (err) {
    console.warn(err);
  }
}
//////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////
function* fetchGlobalAssetUtilization({ cSuitDateFilter, selectedKpi }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    yield put(Actions.setLoader({ showLoader: false }));
    yield put(
      Actions.setGlobalAssetUtilization({
        globalAssetUtilization: [
          { name: 'kWh Consumed', data: [150, -10, 100, 400, 250, 180, 120, -5, -38, -100, 100] },
          { name: 'kWh Per Unit', data: [130, -150, 200, 300, 270, 136, 178, -10, -90, -200, 100] },
          { name: 'kWh per Machine Hour', data: [190, -100, 300, 250, 166, 148, 110, 106, 100, -300, 100] },
          { name: 'Energy Cost', data: [100, 100, 100, 90, 95, 89, 98, 88, 90, 91, 100] },
          { name: 'Planned Runtime vs Total Time', data: [19, 10, 30, 20, 15, 28, 21, 15, 30, 20, 10] },
          { name: 'Actual Runtime', data: [190, 130, 180, 200, 156, 148, 110, 156, 200, 200, 170] },
          { name: 'Runtime vs Make', data: [10, 10, 30, 20, 56, 48, 21, 15, 30, 20, 10] },
          { name: 'Runtime vs Age of asset', data: [90, 60, 70, 120, 56, 48, 10, 56, 30, 20, 100] },
        ],
      })
    );
  } catch (err) {
    console.warn(err);
  }
}
function* fetchSiteAssetUtilization({ selectedSite, cSuitDateFilter, selectedKpi }) {
  try {
    yield put(
      Actions.setSiteAssetUtilization({
        siteAssetUtilization: [
          { name: 'kWh Consumed', data: [150, -10, 100, 400, 250, 180, 120, -5, -38, -100, 100] },
          { name: 'kWh Per Unit', data: [130, -150, 200, 300, 270, 136, 178, -10, -90, -200, 100] },
          { name: 'kWh per Machine Hour', data: [190, -100, 300, 250, 166, 148, 110, 106, 100, -300, 100] },
          { name: 'Energy Cost', data: [100, 100, 100, 90, 95, 89, 98, 88, 90, 91, 100] },
          { name: 'Planned Runtime vs Total Time', data: [19, 10, 30, 20, 15, 28, 21, 15, 30, 20, 10] },
          { name: 'Actual Runtime', data: [190, 130, 180, 200, 156, 148, 110, 156, 200, 200, 170] },
          { name: 'Runtime vs Make', data: [10, 10, 30, 20, 56, 48, 21, 15, 30, 20, 10] },
          { name: 'Runtime vs Age of asset', data: [90, 60, 70, 120, 56, 48, 10, 56, 30, 20, 100] },
        ],
      })
    );
  } catch (err) {
    console.warn(err);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_C_SUITE_MAP_VIEW_GLOBAL_DASHBOARD, fetchMapGlobalDashboard)]);
  yield all([takeLatest(ActionTypes.FETCH_SITE_KPI_DASHBOARD, fetchSiteKpiDashboard)]);
  yield all([takeLatest(ActionTypes.FETCH_GLOBAL_KPI_DASHBOARD, fetchGlobalKpiDashboard)]);
  yield all([takeLatest(ActionTypes.FETCH_KPI_DETAIL_DASHBOARD, fetchKpiDetailDashboard)]);
  yield all([takeLatest(ActionTypes.FETCH_ASSET_UTILIZATION_GLOBAL_DASHBOARD, fetchGlobalAssetUtilization)]);
  yield all([takeLatest(ActionTypes.FETCH_SITE_ASSET_UTILIZATION_GLOBAL_DASHBOARD, fetchSiteAssetUtilization)]);
  yield all([takeLatest(ActionTypes.FETCH_SITE_PERFORMANCE_DETAIL, fetchSitePerformanceDetail)]);
  yield all([takeLatest(ActionTypes.FETCH_KPI_INFORMATION, fetchKpiInformation)]);
  yield all([takeLatest(ActionTypes.FETCH_KPI_LIST, fetchKpiList)]);
  yield all([takeLatest(ActionTypes.FETCH_ALL_KPI_BY_USER, fetchAllKpiByUser)]);
  yield all([takeLatest(ActionTypes.FETCH_USER_KPI_LIST, fetchUserKpiList)]);
  yield all([takeLatest(ActionTypes.ADD_USER_KPI, addUserKpi)]);
  yield all([takeLatest(ActionTypes.UPDATE_USER_KPI_LIST_SORTING, updateUserKpiSorting)]);
  yield all([takeLatest(ActionTypes.DELETE_USER_KPI, deleteUserKpi)]);
  yield all([takeLatest(ActionTypes.UPDATE_USER_KPI, updateUserKpi)]);
}
